import * as angular from 'angular';
import {IController} from "angular";

export class ServicesAssignRouteTableItemComponent implements IController {
  route: any;
  extraVolume: any;
  columns: any;
  onAssign: Function;

  /* @ngInject */
  constructor() {
  }

  $onInit() {

  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('servicesAssignRouteTableItem', {
    bindings: {
      route: '<',
      columns: '<',
      extraVolume: '<?',
      onAssign: '&'
    },
    template: require('./services-assign-route-table-item.html').default,
    controller: ServicesAssignRouteTableItemComponent
  });
